import { onBeforeUnmount, onMounted, type Ref } from 'vue'

/**
 * Dismiss-on-outside for popovers: sets `open` false on a pointerdown outside
 * `root` or on Escape.
 */
export function useClickOutside(root: Ref<HTMLElement | null>, open: Ref<boolean>): void {
  function onPointerDown(e: PointerEvent) {
    if (!open.value) return
    const t = e.target
    if (t instanceof Node && root.value && !root.value.contains(t)) open.value = false
  }

  function onKeydown(e: KeyboardEvent) {
    // defaultPrevented = an inner layer (e.g. a SearchSelect dropdown) already
    // consumed this Escape; one keystroke dismisses one layer, not the stack.
    if (e.key === 'Escape' && !e.defaultPrevented && open.value) {
      open.value = false
      e.preventDefault() // consumed — outer layers listening on window leave theirs open
    }
  }

  onMounted(() => {
    document.addEventListener('pointerdown', onPointerDown)
    document.addEventListener('keydown', onKeydown)
  })
  onBeforeUnmount(() => {
    document.removeEventListener('pointerdown', onPointerDown)
    document.removeEventListener('keydown', onKeydown)
  })
}
